import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

/**
 * Shared modal header showing a title, an optional Previous/Next pager, and a close
 * button. Used by modals that page through a list of records one at a time (e.g. the
 * Change Order History and Review ACR  modals). The caller bakes any position counter
 * into `title` (e.g. "Review ACR 1/3") and controls paging via the inputs/outputs.
 */
@Component({
  selector: 'app-paginated-modal-header',
  templateUrl: './paginated-modal-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginatedModalHeaderComponent {
  readonly title = input.required<string>();
  readonly showNavigation = input(false);
  readonly isFirst = input(false);
  readonly isLast = input(false);

  readonly previous = output<void>();
  readonly next = output<void>();
  readonly closed = output<void>();
}
